import React from 'react';
import style from './index.module.css';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

type ClearRefinementsProps = {
    items: {
        label: string;
        attribute: string;
    }[];
    refine: (items: any) => void;
};

const ClearRefinementsComponent = ({ items, refine }: ClearRefinementsProps) => (
    <button onClick={() => refine(items)} className={`${style.clearAll} ${!items.length ? style.hidden : ''}`}>
        Clear<span> all </span>
        <span> filters </span>
    </button>
);

export const ClearRefinements = connectCurrentRefinements(ClearRefinementsComponent);
